import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=6cae9a35"
import script from "./file-upload.vue?vue&type=script&lang=ts"
export * from "./file-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports